import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-ubs-blog-share',
  templateUrl: './ubs-blog-share.component.html',
  styleUrls: ['./ubs-blog-share.component.scss']
})
export class UbsBlogShareComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
